module.exports = __webpack_public_path__ + "static/material_demo-4fcfb7caaa4a806ca7a5bc44b86bd19b.png";